import { PopoverTrigger } from "@chakra-ui/react"
import { SmileyIcon, SmileyIconV2 } from "@mybridge/icons"
import { Emoji } from "@mybridge/ui/emoji"
import { IconButton } from "@mybridge/ui/icon-button"
import { Popover, PopoverContent } from "@mybridge/ui/popover"
import { Tooltip } from "@mybridge/ui/tooltip"
import { useContext , useState } from "react"
import { PostFormContext } from "../context"
import { Box } from "@mybridge/ui/layout"
import { useDisclosure } from "@mybridge/ui/hooks"
import { useTranslator } from "@mybridge/ui/custom-hooks/useTranslation"

export const EmojiPicker = ({ }) => {
    const { setText, text, textInputRef, setEmojis, textareaRef, caretPosition } = useContext(PostFormContext)
    const emojiDisc = useDisclosure()
    /*const insertAtPos = (value) => {
        // Use the proper ref for cursor position
        const ref = textareaRef?.current || textInputRef?.current;
        if (ref) {
            const startPos = ref.selectionStart;
            const endPos = ref.selectionEnd;
            const textBefore = text.substring(0, startPos);
            const textAfter = text.substring(endPos);
            const newText = textBefore + value.native + textAfter;
            
            setText(newText);
            console.log(newText,"newTesttttt");
            setEmojis(prevState => [...prevState, value])
            // Set cursor position after the inserted emoji
            setTimeout(() => {
                ref.selectionStart = ref.selectionEnd = startPos + value.native.length;
            }, 0);
        } else {
            console.log(value,"newTesttttt2");

            // Fallback to adding to emojis array if no ref available
        }
    };
    */
    const insertAtPos = (value) => {
        // Add emoji to queue - the header component will handle insertion
        // at the correct cursor position (from context) for both Draft.js and textarea
        setEmojis(prevState => [...prevState, value]);
    };
    
    const [iconColor, setIconColor] = useState('');
    const { t } = useTranslator();
    const handleMouseEnter = () => {
        setIconColor('#ffffff');
    };

    const handleMouseLeave = () => {
      setIconColor('');
    };

    return (
        <>
            <Popover {...emojiDisc}>
                <PopoverTrigger>
                    <Box>
                        <Tooltip variant="round" label={t('createPost.addEmoji') || "Add Emoji"}>
                            <IconButton 
                                borderRadius="30px"
                                padding="6px"
                                _hover={{ background: '#3D5A80' }}
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                 icon={<SmileyIconV2 color={iconColor} />} />
                        </Tooltip>
                    </Box>
                </PopoverTrigger>
                <PopoverContent overflow={'auto'} w='full' h={["300px","full"]}>
                    {emojiDisc.isOpen ? <Emoji onEmojiSelect={insertAtPos} /> : ""}
                </PopoverContent>
            </Popover>
        </>
    )
}